$(document).ajaxComplete(function(event, xhr, settings) {
    if (xhr.status === 302) {
        var redirectUrl = xhr.getResponseHeader('X-Redirect');
        if (redirectUrl !== null && typeof redirectUrl !== undefined) {
            var currentDomain = window.location.hostname;
            var responseDomain = new URL(redirectUrl).hostname;
            if (currentDomain === responseDomain) {
                Swal.fire({
                    position: 'top-center',
                    icon: 'info',
                    title: trans("session.timeout.title"),
                    text: trans("session.timeout.description"),
                    showConfirmButton: true,
                    confirmButtonText: 'OK',
                    customClass: { popup: 'vf-confirmation-popup', },
                });
            }
        } else {
            console.error('Redirect URL is null or undefined');
        }
    }
});

// Add Livewire-specific error handling for authentication failures
document.addEventListener('DOMContentLoaded', function() {
    // Handle Livewire authentication failures
    if (typeof Livewire !== 'undefined') {
        console.log("Livewire is defined");
        
        // Intercept Fetch API (which Livewire uses)
        const originalFetch = window.fetch;
        window.fetch = function(url, options = {}) {
            console.log('Fetch intercepted:', url, options);
            
            // Check if this is a Livewire request
            const isLivewireRequest = typeof url === 'string' && url.includes('/livewire/message/');
            
            if (isLivewireRequest) {
                console.log('Intercepting Livewire Fetch request:', url);
                
                return originalFetch.apply(this, arguments)
                    .then(response => {
                        console.log('Livewire Fetch response:', {
                            status: response.status,
                            url: url,
                            ok: response.ok
                        });
                        
                        // Check for authentication/CSRF errors
                        if (response.status === 401 || response.status === 419) {
                            console.log(`${response.status} detected in Livewire Fetch response`);
                            
                            // Clone the response to read it without consuming it
                            const responseClone = response.clone();
                            responseClone.text().then(responseText => {
                                try {
                                    const responseData = JSON.parse(responseText);
                                    if (responseData.redirect && responseData.location) {
                                        handleAuthError(response.status, responseData.location);
                                    } else {
                                        handleAuthError(response.status);
                                    }
                                } catch (e) {
                                    console.error('Failed to parse error response:', e);
                                    handleAuthError(response.status);
                                }
                            });
                            
                            // Return a fake successful response to prevent Livewire error screen
                            // This prevents Livewire from processing the error
                            return new Response(JSON.stringify({
                                serverMemo: {},
                                effects: {
                                    html: '',
                                    dirty: [],
                                    listeners: [],
                                    emits: []
                                }
                            }), {
                                status: 200,
                                statusText: 'OK',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            });
                        }
                        
                        return response;
                    })
                    .catch(error => {
                        console.error('Livewire Fetch error:', error);
                        throw error;
                    });
            }
            
            // For non-Livewire requests, use original fetch
            return originalFetch.apply(this, arguments);
        };
    }
});

// Helper function to handle authentication errors
function handleAuthError(status, redirectUrl = null) {
    const title = status === 419 ? 
        'Session Expired' : 
        (trans("session.timeout.title") || 'Session Expired');
    const text = status === 419 ? 
        'Your session has expired. You will be redirected to login.' : 
        (trans("session.timeout.description") || 'Your session has expired. You will be redirected to login.');
        
    Swal.fire({
        position: 'top-center',
        icon: 'warning',
        title: title,
        text: text,
        showConfirmButton: true,
        confirmButtonText: 'OK',
        customClass: { popup: 'vf-confirmation-popup', },
    }).then((result) => {
        // Redirect to login page
        window.location.href = redirectUrl || '/';
    });
}